import React, { FC, useEffect, useState } from "react"

import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined, LoadingOutlined } from "@ant-design/icons"
import { Button, Modal, Space, Table } from "antd"
import { ColumnsType } from "antd/es/table"

import AddModal from "./AddModal"
import EditModal from "./EditModal"
import { useActions } from "../../../hooks/useActions"
import { useTypedSelector } from "../../../hooks/useTypedSelector"

import "./AccessPage.scss"

const AccessPage: FC = () => {

    const [ addModalOpen, setAddModalOpen ] = useState(false)
    const [ openEditModal, setOpenEditModal ] = useState(false)
    const [ editData, setEditData ] = useState({
        id: 0,
        desc: "",
        address: ""
    })

    const { accessData, isLoading } = useTypedSelector((state) => state.access)
    const { accessFetchData, accessDelete, accessChangeMode } = useActions()

    useEffect(() => {
        accessFetchData()
    }, [])

    const columns: ColumnsType<any> = [
        {
            title: "#",
            dataIndex: "id",
            key: "id",
            width: 50
        },
        {
            title: "IP адрес",
            dataIndex: "address",
            key: "address",
            width: 140,
        },
        {
            title: "Описание",
            dataIndex: "description",
            key: "description",
        },
        {
            title: "Добавлен",
            dataIndex: "created_at",
            key: "created_at",
            width: 150,
        },
        {
            title: "Обновлён",
            dataIndex: "updated_at",
            key: "updated_at",
            width: 150,
        },
        {
            title: "",
            dataIndex: "actions",
            key: "actions",
            width: 80,
            render: (_, record) => (
                <Space size={4}>
                    <Button
                        size="small"
                        icon={<EditOutlined />}
                        onClick={() => {
                            setEditData({
                                id: record.id,
                                address: record.address,
                                desc: record.description
                            })
                            setOpenEditModal(true)
                        }}
                    />
                    <Button
                        size="small"
                        icon={<DeleteOutlined />}
                        onClick={() => {
                            Modal.confirm({
                                title: "Вы уверены что хотите удалить доступ?",
                                icon: <ExclamationCircleOutlined/>,
                                okText: "Да",
                                okType: "danger",
                                cancelText: "Нет",
                                onOk() {
                                    accessDelete(record.id, () => {
                                        accessFetchData()
                                    })
                                },
                            })
                        }}
                        danger
                    />
                </Space>
            )
        },
    ]

    return (
        <div className="page-content">
            <div className="access-actions">
                <Button type="primary" onClick={() => setAddModalOpen(true)}>
                    Добавить доступ
                </Button>

                {accessData.access ? (
                    <Button
                        className="access-mode-btn btn-disable"
                        onClick={() => accessChangeMode(0, () => { accessFetchData() })}
                        loading={isLoading}
                    >
                        Выключить авторизацию
                    </Button>
                ) : (
                    <Button
                        className="access-mode-btn btn-enable"
                        onClick={() => accessChangeMode(1, () => { accessFetchData() })}
                        loading={isLoading}
                    >
                        Включить авторизацию
                    </Button>
                )}
            </div>

            <Table
                className="access-table"
                dataSource={accessData.data}
                columns={columns}
                rowKey="id"
                scroll={{ x: 700, y: 'calc(100vh - 280px)' }}
                loading={{
                    spinning: isLoading,
                    indicator: <LoadingOutlined style={{ fontSize: 24 }} spin />
                }}
                pagination={false}
                size="small"
            />

            <AddModal
                open={addModalOpen}
                setOpen={setAddModalOpen}
            />

            <EditModal
                open={openEditModal}
                setOpen={setOpenEditModal}
                id={editData.id}
                address={editData.address}
                description={editData.desc}
            />
        </div>
    )
}

export default AccessPage
